import styled from 'styled-components'

export const FormGroup = styled.div`
  margin-bottom: 15px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const Label = styled.label`
  width: 100%;
  font-size: 8px;
  margin-bottom: 2px;
  text-transform: uppercase;
  text-align: center;
`

export const Input = styled.input`
  touch-action: manipulation;
  width: 300px;
  color: #677897;
  font-size: 13px;
  height: 40px;
  box-shadow: none;
  border-radius: 2px;
  border: 1px solid #eaeff5;

  display: block;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  background-clip: padding-box;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`

export const Button = styled('button')`
  background: #2196f3;
  border-color: #2196f3;
  color: #fff;

  font-size: 14px;
  border-radius: 2px;
  padding: 0.5rem 1rem;
  letter-spacing: 0.5px;

  display: block;
  width: 100%;

  outline: none;
  border: none;
`



// WEBPACK FOOTER //
// ./src/containers/NewProjectForm/theme.js